module.exports = __webpack_public_path__ + "img/gallery-20x20.414a1be6.svg";